import Link from "next/link";
import { useOfferMode } from "@nju/data-access-portal-offers";
import { portalRoutes } from "@nju/routes";
import { A, Button, Heading, Separator, Text } from "@nju/ui";

interface ISwitchFtthPaymentModalProps {
  closeModal: () => void;
}

export function SwitchFtthPaymentModal({
  closeModal,
}: ISwitchFtthPaymentModalProps) {
  const mode = useOfferMode();

  return (
    <>
      <Heading font="ttfirs" tone="neutral" variant="h2" weight="bold">
        chcesz ponownie zmienić metodę płatności?
      </Heading>
      <Separator size="xs" tone="invisible" />
      <Text
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "l",
        }}
      >
        Zmiana metody płatności z <strong>BLIK lub płatności online</strong> na{" "}
        <strong>kartę płatniczą</strong> została już
        <Separator size="none" tone="invisible" />
        przez Ciebie zlecona i jest w trakcie realizacji. Może to zająć kilka
        minut.
        <Separator size="xs" tone="invisible" />
        Na pewno chcesz ponownie zlecić zmianę metody płatności?
      </Text>
      <Separator size="s" tone="invisible" />
      <div className="flex flex-col-reverse gap-3 from-tablet:flex-row from-tablet:justify-between">
        <Button
          onPress={closeModal}
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
          variant="secondary"
        >
          powrót
        </Button>
        <Link
          href={portalRoutes.mojeKonto.platnosci.index.get({
            zmianaMetodyPlatnosci: "1",
            mode,
          })}
          passHref={true}
        >
          <A
            display={{ "@onlyMobile": "flex", "@fromTablet": "inlineBlock" }}
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            variant="primary"
          >
            tak, zmień metodę płatności
          </A>
        </Link>
      </div>
    </>
  );
}
